import { VAT_MODE } from '~/constants/vatMode';

export const SET_VAT_MODE = 'set_vat_mode';
export const SET_STEPPER_STEP = 'set_stepper_step';

const state = () => ({
  step: 1,
  vatMode: VAT_MODE.INCLUSIVE,
});

const actions = {};

const mutations = {
  [SET_VAT_MODE] (state, payload) {
    state.vatMode = payload;
  },
  [SET_STEPPER_STEP] (state, payload) {
    state.step = payload;
  },
};

const getters = {
  showVatIncl (state) {
    return state.vatMode === VAT_MODE.INCLUSIVE;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
